import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, uploadSurveyPdfApi } from "../utils/Constants";

const authHeaders = () => ({
  Authorization: localStorage.getItem("token"),
});

/**
 * uploadSurveyPdf
 * Sends a FormData payload containing:
 *   - surveyPdf  (File object)
 *   - projectId  (string)
 *   - serviceType (string)
 * Returns { answersImported, serviceType, projectId } on success.
 */
export const uploadSurveyPdf = createAsyncThunk(
  "uploadSurveyPdf/upload",
  async ({ file, projectId, serviceType, patientId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("surveyPdf", file);
      formData.append("projectId", projectId);
      formData.append("serviceType", serviceType);
      formData.append("patientId", patientId);

      const response = await axios.post(
        ApiBaseUrl + uploadSurveyPdfApi,
        formData,
        {
          headers: {
            ...authHeaders(),
            // Do NOT set Content-Type — axios sets multipart boundary automatically
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

const uploadSurveyPdfSlice = createSlice({
  name: "uploadSurveyPdf",
  initialState: {
    isUploading: false,
    uploadResult: null,   // { answersImported, serviceType, projectId }
    error: null,
  },
  reducers: {
    clearUploadSurveyPdf: (state) => {
      state.isUploading = false;
      state.uploadResult = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadSurveyPdf.pending, (state) => {
        state.isUploading = true;
        state.uploadResult = null;
        state.error = null;
      })
      .addCase(uploadSurveyPdf.fulfilled, (state, action) => {
        state.isUploading = false;
        if (action.payload?.status === 1) {
          state.uploadResult = action.payload.data;
        } else {
          state.error = action.payload?.message || "Upload failed";
        }
      })
      .addCase(uploadSurveyPdf.rejected, (state, action) => {
        state.isUploading = false;
        state.error = action.payload?.message || "Upload failed";
      });
  },
});

export const { clearUploadSurveyPdf } = uploadSurveyPdfSlice.actions;
export default uploadSurveyPdfSlice.reducer;